import React from 'react';
import './KineticLoader.css'

const KineticLoader = () => {
    
    return (
        <div className='kinetic-loader-main'>
            <div className="kinetic-loader-container">
                <div className="kinetic-loader"></div>
            </div>
        </div>
    );
};

export default KineticLoader;
